/**
 * 统一的 localStorage、sessionStorage 管理，所有相关的操作都约束在这里
 */

// import { useLocalStorage } from 'react-use';
import store from 'store';

// *****************************************************
// * localStorage 的 key
// *****************************************************
export enum StorageItem {
  MEDIA_SETTING = 'MEDIA_SETTING',
  GUEST_UID = 'GUEST_UID',
  DEVICE_ID = 'DEVICE_ID',
}

// *****************************************************
// * 往 localStorage 添加数据的方法
// * 往 localStorage 查询数据的方法
// * 全部都在这里
// *
// * 命名规则
// * getLocalStorageXXXXXX
// * setLocalStorageXXXXXX
// *
// * 其他地方不能使用 localStorage.get / localStorage.set / store.get / store.set
// *
// *****************************************************
export interface LocalStorageMediaSetting {
  enableAudio: boolean;
  enableVideo: boolean;

  nickname?: string;
}

export const setLocalStorageDefaultMediaSetting = (mediaSetting: LocalStorageMediaSetting) => {
  store.set(StorageItem.MEDIA_SETTING, {
    ...getLocalStorageMediaSetting(),
    ...mediaSetting,
  });
};

export const getLocalStorageMediaSetting = (): LocalStorageMediaSetting => store.get(StorageItem.MEDIA_SETTING) ?? {};

export const setLocalStorageGuestUid = (uid: string) => {
  store.set(StorageItem.GUEST_UID, uid);
};

export const getLocalStorageGuestUid = (): string => store.get(StorageItem.GUEST_UID);

export const setLocalStorageDeviceId = (deviceId: string) => {
  store.set(StorageItem.DEVICE_ID, deviceId);
};

export const getLocalStorageDeviceId = (): string => store.get(StorageItem.DEVICE_ID);
